import { Component, Input } from '@angular/core';
import { TrackingCategory } from '../../models/tracking-categories.ts/trackingCategory';

@Component({
  selector: 'app-totals-line-header-new',
  templateUrl: './totals-line-header-new.component.html',
  styleUrls: ['./totals-line-header-new.component.scss']
})
export class TotalsLineHeaderNewComponent {}
